window._ = require("lodash");

import axios from "axios";

const axiosInstance = axios.create({
  withCredentials: true,
  baseURL: "/api/"
});

// Axios2 intentionally lacks the reset hooks
const axiosInstance2 = axios.create({
  withCredentials: true,
  baseURL: "/api/"
});

window.axios = axiosInstance;
window.axios2 = axiosInstance2;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios2.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";